import React from "react";

function TrainingRequests() {
  const requests = [
    {
      title: "AWS Solution Architect",
      location: "Hassan, Karnataka",
      duration: "3 Months",
      date: "24 Aug 2026",
      status: "PENDING",
    },
    {
      title: "Java DSA",
      location: "Noida",
      duration: "15 Days",
      date: "10 Aug 2026",
      status: "APPROVED",
    },
  ];

  return (
    <div className="page">
      <h1>Training Requests</h1>
      <p>Manage training requirements and requests.</p>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Training</th>
              <th>Location</th>
              <th>Duration</th>
              <th>Start Date</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {requests.map((item, index) => (
              <tr key={index}>
                <td>{item.title}</td>
                <td>{item.location}</td>
                <td>{item.duration}</td>
                <td>{item.date}</td>
                <td>
                  <span className="badge">
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .page > p {
          color:#64748b;
        }

        .card {
          margin-top:25px;
          background:white;
          padding:20px;
          border-radius:12px;
          overflow:auto;
        }

        table {
          width:100%;
          border-collapse:collapse;
        }

        th,td {
          padding:13px;
          border-bottom:1px solid #e2e8f0;
          text-align:left;
        }

        th {
          background:#f8fafc;
        }

        .badge {
          background:#dbeafe;
          color:#1d4ed8;
          padding:5px 10px;
          border-radius:20px;
          font-size:11px;
          font-weight:bold;
        }
      `}</style>
    </div>
  );
}

export default TrainingRequests;